var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tile", {
    staticClass:
      "min-h-[185px] h-[185px] max-w-[300px] min-w-[300px] tile-overwrite",
    attrs: { paddingAmount: 1, showBorder: _vm.quantity > 0 },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _vm.imageSource
              ? _c("div", { staticClass: "wide-image" }, [
                  _c("img", {
                    staticClass: "product-image",
                    attrs: { src: _vm.imageSource },
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "ml-[11px] relative" }, [
              _c("div", { staticClass: "text-left product-info-container" }, [
                _c("div", [
                  _c("h5", { staticClass: "product-name" }, [
                    _vm._v(_vm._s(_vm.productName)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "sku-text" }, [
                    _vm._v(_vm._s(_vm.skuText.replace("-BUNDLE", ""))),
                  ]),
                  _vm._v(" "),
                  _vm.skuText.includes("1226")
                    ? _c(
                        "div",
                        [
                          _c(
                            "svg",
                            _vm._g(
                              {
                                staticClass:
                                  "inline mr-1/4 relative cursor-pointer",
                                class: _vm.cursor - _vm.pointer,
                                attrs: {
                                  width: "20",
                                  height: "20",
                                  viewBox: "0 0 20 20",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              {
                                mouseenter: () => (_vm.open = !_vm.open),
                                mouseleave: () => (_vm.open = !_vm.open),
                              }
                            ),
                            [
                              _c("path", {
                                attrs: {
                                  d: "M9.16663 14.1667H10.8333V9.16675H9.16663V14.1667ZM9.99996 1.66675C5.39996 1.66675 1.66663 5.40008 1.66663 10.0001C1.66663 14.6001 5.39996 18.3334 9.99996 18.3334C14.6 18.3334 18.3333 14.6001 18.3333 10.0001C18.3333 5.40008 14.6 1.66675 9.99996 1.66675ZM9.99996 16.6667C6.32496 16.6667 3.33329 13.6751 3.33329 10.0001C3.33329 6.32508 6.32496 3.33341 9.99996 3.33341C13.675 3.33341 16.6666 6.32508 16.6666 10.0001C16.6666 13.6751 13.675 16.6667 9.99996 16.6667ZM9.16663 7.50008H10.8333V5.83342H9.16663V7.50008Z",
                                  fill: "#00263E",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("Tooltip", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.open === true,
                                expression: "open === true",
                              },
                            ],
                            attrs: { content: _vm.twelveTwentySixDisclaimer },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "quantity-info-container" },
                [
                  _c("CableQuantityToggle", {
                    ref: "selectedQuantity",
                    attrs: {
                      max: _vm.maxPurchasableQuantity,
                      min: _vm.minPurchasableQuantity,
                      default: _vm.startingNumber,
                      maxedOut: _vm.maxedOut,
                    },
                    on: { setProductQuantity: _vm.setQuantity },
                  }),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }